<template>
    <div class="container">
        <!-- 轮播图 -->
        <div id="swiper" class="container-fuild">
            <div class="swiper-container banner-swiper">
                <div class="swiper-slide" v-for="(item,index) in _homeSwiperLists" :key="index">
                    <img v-if="_windowWidth > 768" class="swiper-lazy swiper-lazy-lagre" :src="item.img" alt="轮播图">
                    <img v-else class="swiper-lazy" :src="item.img2" alt="轮播图">
                </div>
                <template  v-if="_windowWidth <= 768">
                    <h3 class="company">骏驰天下</h3>
                    <div class="company__content">
                        <p>一家有温度的IT公司，我们希望通过科技的力量，把爱和温度传递给客户、员工、世界......</p>
                    </div>
                    <div class="company__many" @click="$router.push('/HomePage')">
                        <span>了解更多</span>
                        <span>☞</span>
                    </div>
                </template>
                <!-- 如果需要分页器 -->
                <!--<div class="swiper-img-pagination"></div>-->
                <!-- 如果需要导航按钮 -->
                <!--<div class="swiper-img-button-prev"></div>
                <div class="swiper-img-button-next"></div>-->
            </div>
        </div>
        <div class="g-wrapper">
            <p class="g-title">产品与服务</p>
            <i class="g-title-en">PRODUCTS AND SERVICE</i>
            <div class="server-box">
                <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper" v-for="(item,index) in _homeProductLists" :key="index">
                    <div class="server-block">
                        <img class="center-block" :src="item.imgUrl" alt="logo">
                        <p class="server-block__text ">{{item.title}}</p>
                        <div class="server-block__shadow"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="g-wrapper">
            <p class="g-title">服务领域</p>
            <i class="g-title-en">RANGE OF SERVICES</i>
            <ul class="display-flex flex-row range-box">
                <li class="range-box__item" v-for="(item,index) in _homeRangeList" :key="index" @click="handleText(item.id)">
                    <i :class="['iconfont',item.icon]"></i>
                    <b>{{item.title}}</b>
                </li>
            </ul>
        </div>
        <div class="g-wrapper coop">
            <p class="g-title">合作伙伴</p>
            <i class="g-title-en">COOPERATIVE PARTNER</i>
            <div class="coop-img display-flex flex-row">
                <div class="coop-img__item" v-for="(item,index) in _homeImgList" :key="index">
                    <img :src="item" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";
    import { homeSwiperLists, homeProductLists, homeRangeList, homeImgList} from "../constant/constant";

    export default {
        name: "Home",
        beforeCreate() {
            this._homeSwiperLists = homeSwiperLists;
            this._homeProductLists = homeProductLists;
            this._homeRangeList = homeRangeList;
            this._homeImgList = homeImgList;
            this._windowWidth = window.innerWidth;
            console.log(this._windowWidth)
        },
        data() {
            return {
                customerList: [
                    {title: '企业架构定制化',imgUrl: require('@/assets/img/new-img/pro-icon-1.jpg'),content:'提供企业通用架构，分布式、微服务、云架构、模块化、原子化、服务化、持续集成设计思想。',color:'#F99154'},
                    {title: '功能定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-2.jpg'),color: '#50BFE9',content: '基于Java技术，为客户提供各种个性化功能定制开发，从需求调研项目交付，明理信息科技全力以赴做好每个细节。'},
                    {title: 'APP定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-3.jpg'),color: '#FFB32E',content: '原生APP（IOS/Android）、混合APP。客户需要的，就是明理科技践行提供的。'},
                    {title: '微信小程序定制开发',imgUrl: require('@/assets/img/new-img/pro-icon-4.jpg'),color: '#49CFAD',content: '微信小程序是移动互联网大应用，明理科技全面开启小程序定制开发服务，为移动互联网助力。'},
                ],
                windowWidth: window.innerWidth
            }
        },
        created() {
            this.$nextTick(() => {
                this.handleResize()
            })
        },
        methods: {
            initSwiper() {
                new Swiper(".banner-swiper", {
                    loop: true, // 循环模式选项
                    effect: 'fade',
                    //自动播放
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    // 如果需要分页器
                    pagination: {
                        el: ".swiper-img-pagination",
                        clickable: true
                    },
                    // 如果需要前进后退按钮
                    navigation: {
                        nextEl: ".swiper-img-button-next",
                        prevEl: ".swiper-img-button-prev"
                    },
                    // 延迟加载
                    lazy: {
                        loadPrevNext: true
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true //修改swiper的父元素时，自动初始化swiper
                });
            },
            handleText(id) {
                this.$store.commit('setActive',id);
                this.$router.push('/HomePage')
            },
            handleResize() {
                this._windowWidth = this.windowWidth;
                if(this._windowWidth > 768) {
                    const ratio = this._windowWidth / 1920;
                    const height = 805 * ratio
                    let dom = document.querySelector('#swiper');
                    dom.style.height = `${height}px`

                }else {
                    const ratio = this._windowWidth / 768;
                    const height = 850 * ratio
                    let dom = document.querySelector('#swiper');
                    dom.style.height = `${height}px`
                }
            },
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
    }
</script>

<style scoped lang="scss">
    .container {
        width: 100%;
        padding: 0;
        #swiper {
            position: relative;
        }
        .company {
            position: absolute;
            left: 30px;
            top: 25px;
            margin: 0;
            font-weight: 900;
            color: #fff;
            &__content {
                position: absolute;
                left: 75px;
                top: 70px;
                color: #A1A09F;
                line-height: 27px;
            }
            &__many {
                position: absolute;
                display: flex;
                flex-direction: row;
                align-items: center;
                right: 30px;
                bottom: 30px;
                background: #3B4FE4;
                border-radius: 3px;
                height: 35px;
                border-color: #3B4FE4;
                color: #fff;
                padding: 0 15px;
                span{
                    color: #CFD4F7;
                    &:first-child {
                        margin-right: 8px;
                    }
                }
            }
        }
        .server-box:after{
            content:"";
            display:block;
            visibility:hidden;
            clear:both;
        }
        .server-wrapper {
            padding: 0;
            .server-block {
                width: 100%;
                position: relative;
                overflow: hidden;
                margin-bottom: 60px;

                .center-block {
                    width: 100%;
                }
                &__text {
                    box-sizing: border-box;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 35px;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 35px;
                    text-indent: 10px;
                    background-color: #363643;
                    opacity: .8;
                    z-index: 10;
                    margin-bottom: 0;
                }
                &__shadow {
                    position: absolute;
                    right: 0;
                    bottom: -100%;
                    left: 0;
                    margin: auto;
                    height: 100%;
                    background-color: rgba(46,129,234,.7);
                    background-image: url(../assets/img/new-img/icon-search.png);
                    background-repeat: no-repeat;
                    background-position: center center;
                    transition: bottom 500ms;
                }
                &:hover {
                    .server-block__shadow {
                        bottom: 0;
                    }
                }
            }
        }
        /*服务领域*/
        .range-box {
            flex-wrap: wrap;
            margin-top:20px;
            &__item {
                width: 16.6%;
                height: 100%;
                margin-bottom: 20px;
                position: relative;
                p {
                    line-height: 30px;
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    background: rgba(46,129,234,0.7);
                    padding: 10px;
                    width: 300px;
                    color: #fff;
                    /*height: 100px;*/
                    overflow-y: auto;
                    z-index: 1;
                    box-shadow: 0 0 7px rgba(0, 0, 0, 0.1);
                    display: none;
                    transition: all .3s;
                }
            }
            .iconfont {
                display: block;
                width: 106px;
                height: 106px;
                background-color: #7d8393;
                background-repeat: no-repeat;
                background-position: center center;
                border-radius: 50%;
                text-align: center;
                font-size: 45px;
                line-height: 106px;
                color: #fff;
                margin: auto;
            }
            b {
                display: block;
                height: 30px;
                font-size: 14px;
                text-align: center;
                line-height: 30px;
                color: #000;
                margin: auto;
            }
            @for $i from 1 to 11 {
                .range-box__item:nth-child(#{$i}) {
                    &:hover {
                        .iconfont {
                            background-color: #78cb58;
                        }
                        p {
                            display: block;
                        }
                    }
                }
            }
        }
        .coop {
            .coop-img {
                width: 100%;
                margin-bottom: 60px;
                padding: 20px 15px 0;
                flex-wrap: wrap;
                &__item {
                    display: table-cell;
                    width: calc(25% - 1px);
                    border: 1px solid #ccc;
                    border-right: none;
                    position: relative;
                    &:nth-child(n + 5) {
                        border-top: none;
                    }
                    &:nth-child(4n) {
                        border-right: 1px solid #ccc;
                    }
                }
                img {
                    max-width: 100%;
                    max-height: 120px;
                    position: relative;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%) scale(.7);
                }
            }
        }
    }

    /* 轮播图 */
    #swiper {
        .banner-swiper {
            width: 100%;
            height: 100%;
            .swiper-slide {
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .swiper-slide-title {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 999999999;
                width: 100%;
                height: 100%;
                color: #fff;
                /*background: rgba(51, 51, 51, 0.534);*/
                text-align: right;
                line-height: 30px;
                > h1 {
                    font-size: 50px;
                    margin-top: 12%;
                }
                > p {
                    position: absolute;
                    right: 20px;
                    bottom: 50px;
                    font-size: 20px;
                    margin-top: 1%;
                    font-weight: 700;
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        #swiper {
            height: 450px;
        }
        .container {
            .range-box__item {
                width: 33.3%;
            }
            .coop {
                .coop-img {
                    /*padding: 20px 15px 0;*/
                    &__item {
                        width: calc(50% - 1px);
                        padding: 2px;
                        &:nth-child(2n) {
                            border-right: 1px solid #ccc;
                        }
                        &:nth-child(n + 3) {
                            border-top: none;
                        }
                    }
                    img {
                        max-height: 70px;
                    }
                }
            }
            .server-wrapper .server-block .center-block {
                height: 200px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/Home.vue